import type { UseInfiniteQueryResult } from 'react-query/types/react/types'
import type { PagedResponse } from 'types/paged-response'

/**
 * Constants
 */
export const DEFAULT_NOW_RUNNING_SECTION_PAGE_SIZE = 5

/**
 * Utility functions
 */
export function getTotalItemsFromPaginatedResult<TData>(
  result: UseInfiniteQueryResult<PagedResponse<TData>>
): number {
  return result?.data?.pages.flatMap((pages) => pages.items ?? []).length ?? 0
}
